import Vue from 'vue';
import ElementUI from 'element-ui';
import ShUI from '@sh/sh-ui';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'element-ui/lib/theme-chalk/index.css';
import 'vue-tour/dist/vue-tour.css';
import VueClipboard from 'vue-clipboard2';
import VueTour from 'vue-tour';
import Inputmask from 'inputmask';
import { ShI18n, i18n } from './translate';
import { AUTHORIZATION_OPTIONS } from './config';
import ShAuth from './plugins/ShAuth';
import App from './App';
import store from './store';
import router from './router';
import * as filters from './filters';
import './directives';

import './assets/styles/defs/__colors.sass';
import './assets/styles/style.sass';
import socketService from '@/services/socket.service';

// HOTJAR SCRIPT
import Hotjar from 'vue-hotjar';

Vue.config.productionTip = false;
Vue.prototype.$EventBus = new Vue();
Vue.prototype.$socket = socketService;

dom.watch();

Object.keys(filters.default).forEach(filter => Vue.filter(filter, filters.default[filter]));
Vue.use(ShUI);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});
library.add(fas);
library.add(fab);
Vue.component('icon', FontAwesomeIcon);
Vue.use(VueClipboard);
Vue.use(ShAuth, AUTHORIZATION_OPTIONS, store, router);
Vue.use(ShI18n);
Vue.use(VueTour);
Vue.use(Hotjar, {
  id: '2925507',
  isProduction: true,
});
Vue.directive('mask', {
  bind(el, binding) {
    Inputmask(binding.value).mask(el.getElementsByTagName('INPUT')[0]);
  },
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
